/**
 * 事業アイデアのユーザー評価
 */
export const BusinessIdeaUserEvaluation = {
  GOOD: 'good',
  BAD: 'bad',
} as const

export type BusinessIdeaUserEvaluationType =
  (typeof BusinessIdeaUserEvaluation)[keyof typeof BusinessIdeaUserEvaluation]

export const BusinessIdeaUserEvaluationLabel = {
  [BusinessIdeaUserEvaluation.GOOD]: '良い',
  [BusinessIdeaUserEvaluation.BAD]: '悪い',
}
